"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var ProjectManagerService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProjectManagerService /> class.
     * @param http
     * @param config
     */
    function ProjectManagerService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * List Contracts Async.
     * @param ListContractsPMRequest
     * @returns An Observable containing the model.IPagedList<DeliverableTopReadOnly>
     */
    ProjectManagerService.prototype.ListContractsAsync = function (request) {
        var params = new http_1.HttpParams();
        if (request.page)
            params = params.set('page', request.page.toString());
        if (request.pageSize)
            params = params.set('pageSize', request.pageSize.toString());
        if (request.ownerId)
            params = params.set('ownerId', request.ownerId.toString());
        if (request.feedId)
            params = params.set('feedId', request.feedId.toString());
        if (request.workStatusTypes)
            params = params.set('workStatusTypes', request.workStatusTypes.toString());
        if (request.fromDate)
            params = params.set('fromDate', request.fromDate.toString());
        if (request.toDate)
            params = params.set('toDate', request.toDate.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/projectmanager/contracts/", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * returns a list of unallocated phases
   * @param page
   * @param pageSize
   * @returns An Observable containing the model.IPagedList<SimpleDPhaseWork>
   */
    ProjectManagerService.prototype.ListUnAllocatedPhasesAsync = function (page, pageSize) {
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/projectmanager/unallocated", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Gets a list of all phase lines that have uncreated video units still available
     * Effectively - a list of things to create
     * @param listUncreatedRequest
     * @returns An Observable containing the model.IPagedList<model.SimpleDProject>
     */
    ProjectManagerService.prototype.ListPendingAsync = function (page, pageSize, ownerId, fromDate, toDate, moduleIds) {
        var params = new http_1.HttpParams();
        if (page)
            params = params.set('page', page.toString());
        if (pageSize)
            params = params.set('pageSize', pageSize.toString());
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (moduleIds)
            params = params.set('moduleIds', moduleIds);
        return this.http.get(this.config.DeliverablesApiURL + "/api/projectmanager/pending", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
         * List overdue phases By search parameters
         * @returns An Observable containing the model.IPagedList<SimpleDPhaseWork>
         */
    ProjectManagerService.prototype.ListOverduePhasesAsync = function (page, pageSize, ownerId) {
        var params = new http_1.HttpParams();
        params = params.set('page', page.toString());
        params = params.set('pageSize', pageSize.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/projectmanager/overdue", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * List Phases By search parameters
   * @param listPhasesRequest
   * @returns An Observable containing the IDeliverableAggregatePagedList<Video>
   */
    ProjectManagerService.prototype.ListPhasesAsync = function (listPhasesRequest) {
        var params = new http_1.HttpParams();
        if (listPhasesRequest.page)
            params = params.set('page', listPhasesRequest.page.toString());
        if (listPhasesRequest.pageSize)
            params = params.set('pageSize', listPhasesRequest.pageSize.toString());
        if (listPhasesRequest.ownerId)
            params = params.set('ownerId', listPhasesRequest.ownerId.toString());
        if (listPhasesRequest.workStatusTypes)
            params = params.set('workStatusTypes', listPhasesRequest.workStatusTypes.toString());
        if (listPhasesRequest.productIds)
            params = params.set('productIds', listPhasesRequest.productIds.toString());
        if (listPhasesRequest.fromDate)
            params = params.set('fromDate', listPhasesRequest.fromDate.toString());
        if (listPhasesRequest.toDate)
            params = params.set('toDate', listPhasesRequest.toDate.toString());
        if (listPhasesRequest.currentPhaseWorkTypeId)
            params = params.set('currentPhaseWorkTypeId', listPhasesRequest.currentPhaseWorkTypeId.toString());
        if (listPhasesRequest.feedId)
            params = params.set('feedId', listPhasesRequest.feedId.toString());
        if (listPhasesRequest.orderByCriteria)
            params = params.set('orderByCriteria', listPhasesRequest.orderByCriteria);
        if (listPhasesRequest.hasUnits != null)
            params = params.set('hasUnits', listPhasesRequest.hasUnits.toString());
        if (listPhasesRequest.justOwner != null)
            params = params.set('justOwner', listPhasesRequest.justOwner.toString());
        if (listPhasesRequest.moduleIds)
            params = params.set('moduleIds', listPhasesRequest.moduleIds.toString());
        if (listPhasesRequest.createdFrom)
            params = params.set('createdFrom', listPhasesRequest.createdFrom.toString());
        if (listPhasesRequest.businessUnits)
            params = params.set('businessUnits', listPhasesRequest.businessUnits.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/projectmanager/phases", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List  By search parameters
     * @param listRequest
     * @returns An Observable containing the IDeliverablePagedList<SimpleDProject>
     */
    ProjectManagerService.prototype.ListProjectsAsync = function (listRequest) {
        var params = new http_1.HttpParams();
        if (listRequest.page)
            params = params.set('page', listRequest.page.toString());
        if (listRequest.pageSize)
            params = params.set('pageSize', listRequest.pageSize.toString());
        if (listRequest.ownerId)
            params = params.set('ownerId', listRequest.ownerId.toString());
        if (listRequest.workStatusTypes)
            params = params.set('workStatusTypes', listRequest.workStatusTypes.toString());
        if (listRequest.productIds)
            params = params.set('productIds', listRequest.productIds.toString());
        if (listRequest.fromDate)
            params = params.set('fromDate', listRequest.fromDate.toString());
        if (listRequest.toDate)
            params = params.set('toDate', listRequest.toDate.toString());
        if (listRequest.currentPhaseWorkTypeId)
            params = params.set('currentPhaseWorkTypeId', listRequest.currentPhaseWorkTypeId.toString());
        if (listRequest.feedId)
            params = params.set('feedId', listRequest.feedId.toString());
        if (listRequest.parentPhaseId)
            params = params.set('parentPhaseId', listRequest.parentPhaseId.toString());
        if (listRequest.orderByCriteria)
            params = params.set('orderByCriteria', listRequest.orderByCriteria);
        if (listRequest.moduleIds)
            params = params.set('moduleIds', listRequest.moduleIds.toString());
        if (listRequest.businessUnits)
            params = params.set('businessUnits', listRequest.businessUnits.toString());
        if (listRequest.missingUnits)
            params = params.set('missingUnits', listRequest.missingUnits.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/projectmanager/projects", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ProjectManagerService.ngInjectableDef = i0.defineInjectable({ factory: function ProjectManagerService_Factory() { return new ProjectManagerService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ProjectManagerService, providedIn: "root" });
    ProjectManagerService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProjectManagerService);
ProjectManagerService.ɵfac = function ProjectManagerService_Factory(t) { return new (t || ProjectManagerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ProjectManagerService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProjectManagerService, factory: function (t) { return ProjectManagerService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProjectManagerService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProjectManagerService;
}());
exports.ProjectManagerService = ProjectManagerService;

